/* =================================================================
   br-cta-block — heading reveal + reduced-motion video pause.

   Re-implements the &Fold donor's IX2 action list "a" ("Heading
   UnBlur / 0.1") in vanilla JS: the heading starts at opacity 0 +
   blur(20px) and reveals when scrolled into view (donor
   SCROLL_INTO_VIEW, scrollOffset 20% — approximated here with a -20%
   bottom rootMargin on the observer). The transition itself
   (100ms delay, 1500ms outExpo) lives in the CSS.

   The observer mechanics live in the shared br-motion-reveal utility;
   the hidden "armed" state is applied by arm() ONLY (and never under
   prefers-reduced-motion or without IntersectionObserver), so without
   JS the heading is simply visible. One-shot: the observer disconnects
   after revealing, like the donor's non-looping event.

   Also owns the background video's reduced-motion behaviour (pauses
   it; the poster holds). Without JS the video plays natively, as in
   the donor.
   ================================================================= */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Reduced motion: the band's background video holds its poster
     frame instead of playing (the poster is a frame of the same
     loop, so the band's look is unchanged). The native autoplay may
     win a frame or two before deferred JS runs — the poster and the
     loop's first frames are visually identical anyway. */
  document.querySelectorAll('.br-cta-block').forEach(function (section) {
    var video = section.querySelector('.br-cta-block__video');
    if (video && REDUCED.matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
  });

  if (!window.brMotion || !window.brMotion.reveal) return;

  window.brMotion.reveal({
    scope: '.br-cta-block',
    target: '.br-cta-block__heading',
    rootMargin: '0px 0px -20% 0px' /* donor scrollOffsetValue 20% */,
    arm: function (section) {
      section.classList.add('br-cta-block--armed');
    },
    reveal: function (section) {
      section.classList.remove('br-cta-block--armed');
    },
  });
})();
